<script setup lang="ts">
import { breadcrumbTheme } from '#layers/ui/public';
</script>

<template>
	<div class="truncate text-sm font-semibold" :class="breadcrumbTheme.slots.item">
		<slot />
	</div>
</template>
